import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";


export const getCountAllFriend = async () => {
    const res = await fetchApi.get(API_URL.COUNT_ALL_FRIEND)
    return res.data
}

export const getCountExpectedFriend = async () => {
    const res = await fetchApi.get(API_URL.COUNT_EXPECTED_FRIEND)
    return res.data
}